import React from 'react'

import { cn } from '@/lib/utils.ts'

export interface StatusPopupSystemData {
  system: string
  status: 'ok' | 'error'
  message?: string
}

export interface StatusPopupData {
  messageTitle?: string
  messageText?: string
  statuses: StatusPopupSystemData[]
}

export interface StatusPopupProps extends React.HtmlHTMLAttributes<HTMLDivElement>, StatusPopupData {}

export const StatusPopup = React.forwardRef<HTMLDivElement, StatusPopupProps>(
  ({ className, messageTitle, messageText, statuses, ...props }, ref) => (
    <div
      className={cn(
        'flex w-[312px] flex-col gap-9 rounded-[8px] border border-black bg-white px-4 py-5 shadow-xl',
        className
      )}
      ref={ref}
      {...props}>
      {(messageTitle || messageText) && (
        <div className="flex flex-col gap-2">
          {messageTitle && <p className="text-base font-bold text-red-800">{messageTitle}</p>}
          {messageText && <p className="text-base text-black">{messageText}</p>}
        </div>
      )}

      <div className="flex flex-col gap-2.5">
        {statuses.map((status, index) => (
          <div key={status.system} className="flex flex-col gap-2">
            <div className="flex items-center justify-between px-1">
              <p className="text-[10px] leading-[120%] text-black">{status.system}</p>
              <p
                className={cn(
                  'text-sm font-bold uppercase',
                  status.status === 'ok' ? 'text-green-500' : 'text-red-800'
                )}>
                {status.message || status.status}
              </p>
            </div>
            {index < statuses.length - 1 && <hr className="border-gray-400" />}
          </div>
        ))}
      </div>
    </div>
  )
)
